<div class="main-container">

  <div class="title">
    <span class="title-text">My Activity</span>
    <p class="small-title">Your check-in / check-out actions.</p>
  </div>

  <div class="searchBar">
    <div class="each-div">
      <span class="drop-title">From Date</span>
      <input type="date" class="text-box-active" [formControl]="fromDate" />
    </div>
    <div class="each-div">
      <span class="drop-title">To Date</span>
      <input type="date" class="text-box-active" [formControl]="toDate" />
    </div>
    <div class="btn">
      <button type="button" class="ac-primary-btn" (click)="load()">Search</button>
    </div>
  </div>

  <div class="table-container">
    <table class="table">
      <thead class="table-head">
        <tr>
          <th>Time</th>
          <th>Action</th>
          <th>Details</th>
          <th>Operator</th>
        </tr>
      </thead>
      <tbody class="table-body">
        @for(row of activity; track row.id){
        <tr>
          <td>{{ row.time }}</td>
          <td>{{ row.action }}</td>
          <td class="details-cell">{{ row.details }}</td>
          <td>{{ row.operator }}</td>
        </tr>
        }
        @if(!isLoading && activity.length === 0){
        <tr>
          <td colspan="4" class="empty-row">No activity found.</td>
        </tr>
        }
      </tbody>
    </table>
  </div>

</div>

<app-loader [isLoading]="isLoading"></app-loader>
